import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useDisableScroll } from '../../hooks/useDisableScroll';
import ReactDOM from 'react-dom';
var SELECTOR_ID = 'XOverlay-container';
export function XOverlay(_a) {
    var children = _a.children, className = _a.className, onClose = _a.onClose;
    var element = useState(document.createElement('div'))[0];
    useDisableScroll(true);
    useEffect(function () {
        var containerElement = getContainerElement();
        containerElement.appendChild(element);
        return function () {
            containerElement.removeChild(element);
        };
    }, []);
    function getContainerElement() {
        var element = document.querySelector("#" + SELECTOR_ID);
        if (!element) {
            element = document.createElement('div');
            element.id = SELECTOR_ID;
            document.documentElement.appendChild(element);
        }
        return element;
    }
    return ReactDOM.createPortal(React.createElement("div", { className: clsx(className, 'XOverlay'), onClick: onClose }, children), element);
}
